import { render } from "./ContentLayout.vue?vue&type=template&id=e06faf5a"
import script from "./ContentLayout.vue?vue&type=script&lang=js"
export * from "./ContentLayout.vue?vue&type=script&lang=js"

import "./ContentLayout.vue?vue&type=style&index=0&id=e06faf5a&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__